/**
 * English: Fetch paginated task run history from /api/tasks for the inbox UI.
 * Thai: ดึงประวัติ task run แบบแบ่งหน้าจาก /api/tasks สำหรับ UI inbox
 */
import { useState, useCallback, useEffect } from 'react';
import { useApi } from './useApi';
import { ENDPOINTS } from '../config/api';
import { TaskRun } from '../types';

interface UseTaskRunsOptions {
  stationId?: string;
  orgName?: string;
}

export function useTaskRuns(limit = 50, stationOrOptions?: string | UseTaskRunsOptions) {
  const { get } = useApi();
  const [runs, setRuns] = useState<TaskRun[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const stationId = typeof stationOrOptions === 'string' ? stationOrOptions : stationOrOptions?.stationId;
  const orgName = typeof stationOrOptions === 'string' ? undefined : stationOrOptions?.orgName;

  const refresh = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const params: Record<string, string> = { limit: String(limit) };
      if (stationId) params.station_id = stationId;
      if (orgName) params.org_name = orgName;
      const data = (await get(ENDPOINTS.taskRuns, params)) as TaskRun[];
      setRuns(Array.isArray(data) ? data : []);
    } catch (e) {
      setError((e as Error).message);
    } finally {
      setLoading(false);
    }
  }, [get, limit, orgName, stationId]);

  useEffect(() => { refresh(); }, [refresh]);

  return { runs, loading, error, refresh };
}
